import { render, staticRenderFns } from "./TraceabilityLogisticBatches.vue?vue&type=template&id=23824218&scoped=true"
import script from "./TraceabilityLogisticBatches.vue?vue&type=script&lang=js"
export * from "./TraceabilityLogisticBatches.vue?vue&type=script&lang=js"
import style0 from "./TraceabilityLogisticBatches.vue?vue&type=style&index=0&id=23824218&prod&lang=scss&scoped=true"
import style1 from "./TraceabilityLogisticBatches.vue?vue&type=style&index=1&id=23824218&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23824218",
  null
  
)

export default component.exports